import {normalize, schema} from 'normalizr';

export default function normalizeAreaZoneStation(originalData) {

    const area = new schema.Entity('areas');

    const zone = new schema.Entity('zones', {area: area});

    const station = new schema.Entity('stations', {zone: zone});

    return normalize(originalData, [station]);
}




// WEBPACK FOOTER //
// ./src/models/schemas/schemas.js